import Banner from "./Banner";
import Regulamin from "./files/AKREDYTACJA_REGULAMIN_REKRUTACJI.pdf";

let Recruitment = () => {
    return(
        <div id = "textContainer">
            
            <h1>Rekrutacja</h1>
            <hr />
            <Banner />
            <hr /> <br />
            <h2><strong>Informacje o procesie rekrutacji</strong></h2>
            <p>Uczniowie z klas III i IV technikum ubiegający się o staż zagraniczny w ramach Projektu będą podlegali ocenie według następujących kryteriów:</p>
            <ul>
                <hr className="customRecruitment"/>
                
                <h3><strong>Dla uczniów klas III</strong></h3>
                <li>oceny roczne z przedmiotów zawodowych z klasy II dla uczniów klas o profilu technik informatyk:
                    <ul>
                        <li>Urządzenia techniki komputerowej</li>
                        <li>Administracja systemami operacyjnymi</li>
                        <li>Montaż i konfiguracja lokalnych sieci komputerowych</li>
                    </ul>
                </li>
                <li>oceny roczne z przedmiotów zawodowych z klasy II dla uczniów klas o profilu technik teleinformatyk:
                    <ul>
                        <li>Administracja sieciowymi systemami komputerowymi</li>
                        <li>Konfigurowanie urządzeń sieciowych</li>
                        <li>Sieci lokalne</li>   
                    </ul>
                </li>
                <li>oceny roczne z przedmiotów zawodowych z klasy II dla uczniów klas o profilu technik programista:
                    <ul>
                        <li>Programowanie aplikacji internetowych</li>
                        <li>Tworzenie i zarządzanie bazami danych</li>
                        <li>Programowanie strukturalne i obiektowe w języku Java</li>   
                    </ul>
                </li>
                <li>ocena roczna z języka angielskiego z klasy II</li>
                <li>frekwencja na zajęciach lekcyjnych z klasy II</li>
                <li>test z języka angielskiego</li>
                <li>test kompetencji z zakresu ICT</li>
                <li>opinia wychowawcy</li>
                <li>rozmowa kwalifikacyjna w języku angielskim</li>


                <hr className="customRecruitment"/>
                
                <h3><strong>Dla uczniów klas IV</strong></h3>
                <li>oceny roczne z przedmiotów zawodowych z klasy III dla uczniów klas o profilu technik informatyk:
                    <ul>
                        <li>Witryny i aplikacje internetowe</li>
                        <li>Administracja systemami operacyjnymi</li>
                        <li>Montaż i konfiguracja lokalnych sieci komputerowych</li>
                    </ul>
                </li>
                <li>oceny roczne z przedmiotów zawodowych z klasy III dla uczniów klas o profilu technik teleinformatyk:
                    <ul>
                        <li>Administracja sieciowymi systemami komputerowymi</li>
                        <li>Konfigurowanie urządzeń sieciowych</li>
                        <li>Sieci lokalne</li>   
                    </ul>
                </li>
                <li>oceny roczne z przedmiotów zawodowych z klasy III dla uczniów klas o profilu technik programista:
                    <ul>
                        <li>Programowanie aplikacji internetowych</li>
                        <li>Projektowanie aplikacji mobilnych</li>
                        <li>Projektowanie aplikacji desktopowych</li>   
                    </ul>
                </li>
                <li>ocena roczna z języka angielskiego z klasy III</li>
                <li>frekwencja na zajęciach lekcyjnych z klasy III</li>
                <li>test z języka angielskiego</li>
                <li>test kompetencji z zakresu ICT</li>
                <li>opinia wychowawcy</li>
                <li>rozmowa kwalifikacyjna w języku angielskim</li>
                
            </ul>

            <hr className="customRecruitment"/>

            <p>Oceny z przedmiotów zawodowych oraz z języka angielskiego przeliczane są na punkty:</p>
            <ul>
                <li>ocena celująca: 6 punktów</li>
                <li>ocena bardzo dobra: 5 punktów</li>
                <li>ocena dobra: 4 punkty</li>
                <li>ocena dostateczna: 3 punkty</li>
                <li>ocena dopuszczająca: 2 punkty</li>
                <li>ocena niedostateczna: 0 punktów</li>
            </ul>

            <p>Oceny z testów z zakresu ICT i języka angielskiego przeliczane są na punkty:</p>
            <ul>
                <li>ocena celująca: 12 punktów</li>
                <li>ocena bardzo dobra: 10 punktów</li>
                <li>ocena dobra: 8 punktów</li>
                <li>ocena dostateczna: 3 punkty</li>
                <li>ocena dopuszczająca: 1 punkty</li>
                <li>ocena niedostateczna: 0 punktów</li>
            </ul>

            <p>Oceny z testów z zakresu ICT i języka angielskiego ustala się na podstawie następującej skali procentowej:</p>
            <table className="table table-bordered table-hover w-50 mx-auto">
                <thead>
                    <tr>
                        <th>Procentowy wynik</th>
                        <th>Ocena</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>96% - 100%</td>
                        <td>celujący</td>
                    </tr>
                    <tr>
                        <td>85% - 95%</td>
                        <td>bardzo dobry</td>
                    </tr>
                    <tr>
                        <td>70% - 84%</td>
                        <td>dobry</td>
                    </tr>
                    <tr>
                        <td>50% - 69%</td>
                        <td>dostateczny</td>
                    </tr>
                    <tr>
                        <td>30% - 49%</td>
                        <td>dopuszczający</td>
                    </tr>
                    <tr>
                        <td>0% - 29%</td>
                        <td>niedostateczny</td>
                    </tr>
                </tbody>
            </table>

            <p>Frekwencja ucznia na obowiązkowych zajęciach lekcyjnych punktowana jest następująco:</p>
                <ul>
                    <li>90% - 100%: 10 punktów</li>
                    <li>75% - 89%: 8 punktów</li>
                    <li>60% - 74%: 6 punktów</li>
                    <li>50% - 59%: 2 punkty</li>
                    <li>poniżej 50%: 0 punktów</li>
                </ul>

            <p>Ocena wychowawcy klasy uwzględniająca funkcjonowanie ucznia w środowisku szkolnym, respektowanie zasad współżycia społecznego i ogólnie przyjętych norm etycznych będzie punktowan w skali od 0 do 12 punktów:</p>
            <ul>
                <li>kultura osobista: 0 - 6 punktów</li>
                <li>praca w samorządzie szkolnym: 0 - 1 punkt</li>
                <li>praca w radiowęźle szkolnym: 0 - 1 punkt</li>
                <li>praca w wolontariacie szkolnym: 0 - 1 punkt</li>
                <li>udział w międzyszkolnych konkursach przedmiotowych/zawodach sportowych: 0 - 1 punkt</li>
                <li>zaangażowanie w pracę na rzecz klasy: 0 - 1 punkt</li>
                <li>praca doraźna na rzecz Szkoły (Kiermasz Świąteczny, Szlachetna Paczka, Maraton Pisania Listów, Poczet Sztandarowy, zbiórki charytatywne): 0 - 1 punkt</li>
            </ul>

            <p>Rozmowa kwalifikacyjna oceniana jest w skali od 0 do 30 pkt. według następujących kryteriów:</p>
            <ul>
                <li>treść: 0 - 8 pkt.</li>
                <li>kompetencje komunikacyjne: 0 - 9 pkt.</li>
                <li>zakres środków leksykalno-gramatycznych: 0 - 7 pkt.</li>
                <li>poprawność środków leksykalno-gramatycznych: 0 - 4 pkt.</li>
                <li>ogólne wrażenie/swoboda wypowiedzi: 0 - 2 pkt.</li>
            </ul>

            <hr className="customRecruitment"/>
            
            <p><strong>Uczeń ubiegający się o staż zagraniczny zobligowany jest do wypełnienia, podpisania i wydrukowania Karty kwalifikacyjnej przystąpienia do Projektu zamieszczonej na stronie internetowej Szkoły oraz dostarczenia jej do sekretariatu Szkoły. Ponadto uczeń musi także wypełnić Formularz online dostępny na szkolnej stronie internetowej. Niedopełnienie ww. warunków formalnych rekrutacji spowoduje, że uczeń nie będzie ujęty w dalszym procesie rekrutacji.</strong></p>
            
            <p>Językiem komunikacji w trakcie stażu zagranicznego jest język angielski. W związku z powyższym uczeń ubiegający się o udział w stażu musi posługiwać się językiem angielskim w stopniu komunikatywnym. O kolejności uczniów na liście podstawowej i rezerwowej decyduje poziom komunikatywności ucznia w języku angielskim.</p>
            
            <p><strong>W wyniku przeprowadzonej rekrutacji sporządzona będzie lista podstawowa (24 osoby) oraz lista rezerwowa (6 osób).</strong></p>

            <p><strong>Pełna wersja Regulaminu rekrutacji i uczestnictwa w Projekcie znajduje się <a href="https://www.zsi.kielce.pl/wp-content/uploads/2024/11/Regulamin_rekrutacji_2024.pdf" target="_blank">TUTAJ</a>.</strong></p>

            <hr className="customRecruitment"/>
            
            <p className = "text-center"><em>Uczniowi przysługuje prawo odwołania do dyrektora Zespołu Szkół Informatycznych w Kielcach w terminie 7 dni od momentu ogłoszenia decyzji Komisji Rekrutacyjnej w przypadku naruszenia Regulaminu rekrutacji i uczestnictwa w Projekcie. Odwołanie musi zawierać przyczynę jego składania wraz z uzasadnieniem. Decyzja Dyrektora jest ogłaszana najpóźniej następnego dnia po rozpatrzeniu sprawy i jest ostateczna.</em></p>  
        </div>
        
    )
}

export default Recruitment;